import { useAlert, useSetAlert } from "@/app/_hooks/useAlertContext";
import { Alert as MantineAlert } from "@mantine/core";
import {
  IconInfoCircle,
  IconCircleCheck,
  IconAlertCircle,
} from "@tabler/icons-react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";

const Alert = () => {
  const setAlert = useSetAlert();
  const alert = useAlert();
  let color = "blue";
  let Icon = IconInfoCircle;

  switch (alert?.type) {
    case "success":
      color = "green";
      Icon = IconCircleCheck;
      break;
    case "error":
      color = "red";
      Icon = IconAlertCircle;
      break;
    case "warning":
      color = "orange";
      Icon = IconAlertCircle;
      break;
    case "info":
      color = "blue";
      Icon = IconInfoCircle;
      break;
  }

  useEffect(() => {
    if (alert && !alert.persistent) {
      setTimeout(() => {
        setAlert(null);
      }, alert.duration || 7500);
    }
  }, [alert, setAlert]);

  return (
    <AnimatePresence>
      {alert && (
        <motion.div
          initial={{ x: "100%", opacity: 0 }}
          exit={{ x: "100%", opacity: 0 }}
          animate={{ x: "0", opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 10000,
          }}
        >
          <MantineAlert
            variant="filled"
            color={color}
            withCloseButton
            onClose={() => setAlert(null)}
            title={alert.title ? alert.title : ""}
            icon={<Icon />}
            maw={{ base: 375, lg: 450 }}
            miw={{ base: 375, lg: 350 }}
            w={"100%"}
          >
            {alert.content}
          </MantineAlert>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Alert;
